export enum SupportedLocales {
  English = "en",
  Chinese = "zh-Hans",
  TraditionalChinese = "zh-Hant",
  Spanish = "es",
  French = "fr",
  German = "de",
  Italian = "it",
  Portuguese = "pt",
  Russian = "ru",
  Japanese = "ja",
  Korean = "ko",
  Arabic = "ar",
  Hindi = "hi",
  Indonesian = "id",
  Turkish = "tr",
  Vietnamese = "vi",
  Thai = "th",
  Dutch = "nl",
  Polish = "pl",
  Malay = "ms",
}

const supportedLocales = new Set<string>(Object.values(SupportedLocales));

export const normalizeUiLocale = (value?: string): SupportedLocales => {
  if (!value) return SupportedLocales.English;
  const locale = value.replace(/_/g, "-");
  const lower = locale.toLowerCase();
  if (lower.startsWith("zh")) {
    return lower.includes("hant") || lower.includes("tw") || lower.includes("hk") || lower.includes("mo")
      ? SupportedLocales.TraditionalChinese
      : SupportedLocales.Chinese;
  }
  const primary = lower.split("-")[0];
  if (primary === "in") return SupportedLocales.Indonesian;
  return supportedLocales.has(primary) ? (primary as SupportedLocales) : SupportedLocales.English;
};

export type ServiceLocale = "en" | "zh" | "ru";

export const serviceLocale = (value?: string): ServiceLocale => {
  const locale = normalizeUiLocale(value);
  if (locale.startsWith("zh-")) return "zh";
  return locale === SupportedLocales.Russian ? "ru" : "en";
};

export const assetLocale = (value?: string): ServiceLocale => serviceLocale(value);

export const initialUiLocale = (): SupportedLocales => {
  const query = new URLSearchParams(window.location.search);
  return normalizeUiLocale(query.get("lang") || localStorage.getItem("appLocale") || navigator.language);
};
